import { trackGearEvent, installGearNavigationTracking } from './gear-analytics.js';

const cards = [...document.querySelectorAll('.product-card')];
const sections = [...document.querySelectorAll('[data-category-section]')];
const controls = document.querySelector('.category-controls');
const filters = [...controls.querySelectorAll('[data-filter]')];

function filterCategory(category, track = true) {
  sections.forEach(section => { section.hidden = category !== 'all' && section.dataset.categorySection !== category; });
  filters.forEach(button => { button.setAttribute('aria-pressed', String(button.dataset.filter === category)); });
  const count = cards.filter(card => category === 'all' || card.dataset.category === category).length;
  const label = filters.find(button => button.dataset.filter === category).textContent;
  document.getElementById('product-count').textContent = `${count} recommendations${category === 'all' ? '' : ` in ${label}`}`;
  if (track) trackGearEvent('product_category_select', { category: label, page_path: '/prod' });
}

controls.addEventListener('click', event => {
  const button = event.target.closest('button[data-filter]');
  if (button) filterCategory(button.dataset.filter);
});
controls.hidden = false;

// Featured anchors and direct product fragments always reveal their destination,
// even after the visitor has filtered another category.
function revealFragment() {
  const target = document.getElementById(window.location.hash.slice(1));
  if (target?.classList.contains('product-card') && target.closest('section').hidden) filterCategory('all', false);
  return target;
}
document.querySelectorAll('[data-featured-link]').forEach(link => link.addEventListener('click', () => filterCategory('all', false)));
window.addEventListener('hashchange', () => { const target = revealFragment(); target?.scrollIntoView({ block: 'start' }); });
revealFragment();

function trackProduct(event) {
  if (event.type === 'auxclick' && event.button !== 1) return;
  const link = event.target.closest('a[data-product-link]');
  if (!link) return;
  const card = link.closest('.product-card');
  const visibleCards = cards.filter(item => !item.closest('[data-category-section]').hidden);
  const destination = new URL(link.href);
  const asin = destination.hostname === 'www.amazon.com' && destination.pathname.match(/\/dp\/([A-Z0-9]{10})/);
  // Only the catalog destination is sent, never incoming query strings,
  // map/CAD state, user identifiers, or a referrer URL.
  trackGearEvent('product_click', {
    product_id: card.dataset.productId,
    product_name: card.dataset.productName,
    product_category: card.dataset.productCategory,
    product_position: visibleCards.indexOf(card) + 1,
    destination_domain: destination.hostname,
    // GA4 string parameters have a length limit. Report the canonical product
    // destination, keeping affiliate/campaign queries on the actual link only.
    destination_url: asin ? `https://www.amazon.com/dp/${asin[1]}` : `${destination.origin}${destination.pathname}`,
    affiliate: card.dataset.affiliate === 'true',
    page_path: '/prod',
  });
}
document.addEventListener('click', trackProduct);
document.addEventListener('auxclick', trackProduct);

document.querySelectorAll('[data-product-image]').forEach(image => {
  const show = () => { if (image.naturalWidth > 0) image.classList.add('is-loaded'); };
  image.addEventListener('load', show);
  image.addEventListener('error', () => image.remove());
  if (image.complete) { if (image.naturalWidth > 0) show(); else image.remove(); }
});
document.querySelectorAll('[data-copyright-year]').forEach(element => { element.textContent = new Date().getFullYear(); });
installGearNavigationTracking();
trackGearEvent('prod_view', { page_path: '/prod', page_title: document.title });
